import { cloneElement, type ReactElement } from 'react';
import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const UPGRADE_TO_ENABLE = 'Upgrade to Enable';

/**
 * Leaves a control visible, blocks activation, and shows Upgrade to Enable
 * while the pointer is over it.
 */
export function UpgradeHoverLock({
  locked,
  children,
}: {
  locked: boolean;
  children: ReactElement;
}) {
  if (!locked) return children;
  const lockedChild = cloneElement(children, {
    tabIndex: -1,
    'aria-disabled': true,
    onClick: (event: {
      preventDefault: () => void;
      stopPropagation: () => void;
    }) => {
      event.preventDefault();
      event.stopPropagation();
    },
  });
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={<span className="tw:inline-flex tw:cursor-not-allowed" />}
        >
          <span className="tw:pointer-events-none tw:inline-flex tw:opacity-60">
            {lockedChild}
          </span>
        </TooltipTrigger>
        <TooltipContent>{UPGRADE_TO_ENABLE}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

/** A notification choice that stays visible and cannot be turned on. */
export function LockedUpgradeOption({ label }: { label: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={
            <span className="tw:inline-flex tw:cursor-not-allowed tw:opacity-60" />
          }
        >
          <StylishNewCheckbox checked={false} disabled label={label} />
        </TooltipTrigger>
        <TooltipContent>{UPGRADE_TO_ENABLE}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
